export default __webpack_public_path__ + "static/media/IMG_0461.5513a9a3.jpg";